import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeEducationConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmployeeEducationService } from './api/employeeEducation.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeEducationApiModule {
    public static forRoot(configurationFactory: () => EmployeeEducationConfiguration): ModuleWithProviders<EmployeeEducationApiModule> {
        return {
            ngModule: EmployeeEducationApiModule,
            providers: [ { provide: EmployeeEducationConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeEducationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeEducationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
